var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTradeInHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0e2240"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 1.5A10.5 10.5 0 1 0 22.5 12 10.51 10.51 0 0 0 12 1.5M12 0A12 12 0 1 1 0 12 12 12 0 0 1 12 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.382 16.144H7.001v-1.5h10.381Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.78 19.056-1.061-1.061 2.6-2.6-2.6-2.6 1.061-1.061 3.662 3.662ZM7 8.382h11.043v1.5H7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.601 5.47 1.061 1.061-2.6 2.6 2.6 2.6-1.061 1.061L5.939 9.13Z"
}))));
export { SvgTradeInHistory as ReactComponent };
export default "/_next/static/images/trade_in_history.svg";